var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tl-empty-item column items-center text-grey"},[_c('q-icon',{attrs:{"name":"fas fa-box-open","size":_vm.iconSize}}),_c('span',{staticClass:"q-mt-sm",style:({
      fontSize: _vm.textSize,
    })},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }